import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';
import guTranslation from './locales/gu/translation.json';

const LANG_KEY = 'srrd_lang';

const savedLang = localStorage.getItem(LANG_KEY) || 'gu';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      gu: { translation: guTranslation },
    },
    lng: savedLang,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

// Keep <html lang="..."> in sync so CSS font rules work
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  localStorage.setItem(LANG_KEY, lng);
});

// Set initial lang attribute
document.documentElement.lang = savedLang;

export default i18n;
